import { render, staticRenderFns } from "./PassengerUtilityMapper.vue?vue&type=template&id=a67e583c"
import script from "./PassengerUtilityMapper.vue?vue&type=script&lang=ts"
export * from "./PassengerUtilityMapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports